import type { CardId } from '../../core/cards.js';
import { bestOfAny, bestOfExact, toFast } from './evaluator.js';

/**
 * A poker variant plugs dealing + hand evaluation + betting structure into the shared betting engine.
 * Adding a variant (e.g. Short Deck, Omaha Hi-Lo) means adding an entry here — the engine is untouched.
 */
export interface PokerVariant {
  id: PokerVariantId;
  name: string;
  holeCards: number;
  bettingStructure: 'no-limit' | 'pot-limit';
  evaluate(hole: readonly CardId[], board: readonly CardId[]): number;
}

export type PokerVariantId = 'NLHE' | 'PLO';

export const POKER_VARIANTS: Record<PokerVariantId, PokerVariant> = {
  NLHE: {
    id: 'NLHE',
    name: "No-Limit Texas Hold'em",
    holeCards: 2,
    bettingStructure: 'no-limit',
    evaluate: (hole, board) => bestOfAny([...hole, ...board].map(toFast)),
  },
  PLO: {
    id: 'PLO',
    name: 'Pot-Limit Omaha',
    holeCards: 4,
    bettingStructure: 'pot-limit',
    evaluate: (hole, board) => bestOfExact(hole.map(toFast), board.map(toFast), 2),
  },
};
